import angular from 'angular';
import '../../../../services/cart';
import '../../../../filters/sum';
angular.module('folkeuni').component('cartProductDiscount', {
  templateUrl: '/shop-dist/templates/cart-product-discount.html?c=' + window.cacheBurst,
  bindings:{
    product:'<',
    state: '<'
  },
  controller: function (Cart) {
      var $ctrl = this;
  }
});
